import get from 'lodash/fp/get';
import queryString from 'query-string';
import { createSelector } from 'reselect';
import {
  languageCodePostTypeMap,
} from 'config/types/language';
import {
  archivePaths,
} from 'config/types/path';
import landingPageTypePathTypeMap from 'config/types/landingPage';
import { boundGetFirstMatch } from './getFirstMatch';

const getMatch = createSelector(
  [
    get('router'),
    boundGetFirstMatch,
  ],
  ({ location }, match) => {
    const { pathType, params: { contentType } } = match;
    const isArchive = archivePaths.includes(pathType) ||
      Object.keys(landingPageTypePathTypeMap).includes(pathType);
    const isLanding = Object.keys(landingPageTypePathTypeMap)
      .includes(match.pathType);
    const isMultipleContentType = isArchive && !contentType;

    const query = queryString.parse(location.search || '', {
      arrayFormat: 'bracket',
    });

    return {
      ...match,
      url: match.url || location.pathname,
      isArchive,
      isLanding,
      isMultipleContentType,
      query,
    };
  },
);

export const getLanguage = createSelector(boundGetFirstMatch, (match) => (
  match.params.language
));

export const getContentType = createSelector(
  [getMatch],
  ({ params }) => languageCodePostTypeMap[params.language] ||
    params.contentType,
);

export const getArticleSlug = createSelector(
  [getMatch],
  ({ params }) => params.slug,
);

export const getPathType = createSelector(
  [getMatch],
  ({ pathType }) => pathType,
);

export const getUrl = createSelector(
  [getMatch],
  ({ url }) => url,
);

export const getQuery = createSelector(
  [getMatch],
  ({ query }) => query,
);

export default getMatch;
